"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.invisible = invisible;
exports.default = void 0;

// Visibility

/**
 * @public
 * @description Forces visibility value with !important
 * @param visibility
 * @returns {string}
 */
function invisible(visibility) {
  return "\n    visibility: ".concat(visibility, " !important;\n  ");
}

var _default = {
  invisible: invisible
};
exports.default = _default;